module.exports = __webpack_public_path__ + "img/asaf_avidan_10s_octobre_2021.8d7780c0.jpg";